export enum WorkArrangement {
  NotDefined = 0,
  Office = 1,
  Hybrid = 2,
  Remote = 3,
}
